import React from "react";
import Proptypes from "prop-types";
import styled from "styled-components";
import { compose, color, typography } from "styled-system";
import { Badge as PRBadge } from "primereact/badge";

const StyledBadge = styled(PRBadge)`
  ${compose(color, typography)};
  background-color: var(--primary) !important;
  color: var(--white) !important;
`;

const Badge = ({ value = null }) => {
  return <StyledBadge value={value} />;
};

Badge.propTypes = {
  value: Proptypes.number,
};

export default Badge;
